export default __webpack_public_path__ + "static/media/logo-short.828472ce.svg";